import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const SelectOption = ({ options, selected, onChange }) => {
    return (
        <Box sx={{ minWidth: 120, paddingBlock: '0.5rem' }}>
            <FormControl fullWidth>
                <InputLabel id="select-label">Option</InputLabel>
                <Select
                    labelId="select-label"
                    id="select"
                    value={selected}
                    label="Option"
                    onChange={onChange}
                >
                    {options.map((option) => {
                        return <MenuItem key={option.name} value={option.value}>
                            {option.name}
                        </MenuItem>
                    })}
                </Select>
            </FormControl>
        </Box>
    );
}

export default SelectOption;